'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var XS = exports.XS = 'xs';
var S = exports.S = 's';
var L = exports.L = 'l';
var XL = exports.XL = 'xl';

var SIZES = exports.SIZES = [XS, S, L, XL];

var CONTRACT = exports.CONTRACT = 'contract';
var CONTRACT_OVERLAY = exports.CONTRACT_OVERLAY = 'contract-overlay';
var EXPAND_LEFT = exports.EXPAND_LEFT = 'expand-left';
var EXPAND_RIGHT = exports.EXPAND_RIGHT = 'expand-right';
var EXPAND_UP = exports.EXPAND_UP = 'expand-up';
var EXPAND_DOWN = exports.EXPAND_DOWN = 'expand-down';
var SLIDE_LEFT = exports.SLIDE_LEFT = 'slide-left';
var SLIDE_RIGHT = exports.SLIDE_RIGHT = 'slide-right';
var SLIDE_UP = exports.SLIDE_UP = 'slide-up';
var SLIDE_DOWN = exports.SLIDE_DOWN = 'slide-down';
var ZOOM_IN = exports.ZOOM_IN = 'zoom-in';
var ZOOM_OUT = exports.ZOOM_OUT = 'zoom-out';

var STYLES = exports.STYLES = [CONTRACT, CONTRACT_OVERLAY, EXPAND_LEFT, EXPAND_RIGHT, EXPAND_UP, EXPAND_DOWN, SLIDE_LEFT, SLIDE_RIGHT, SLIDE_UP, SLIDE_DOWN, ZOOM_IN, ZOOM_OUT];


//////////////////
// WEBPACK FOOTER
// ../~/_react-ladda@5.0.7@react-ladda/dist/constants.js
// module id = 678
// module chunks = 0